export const pageNames = {
    index: 'index',
    services: 'services',
    team: 'team',
    references: 'references',
    career: 'career',
    contact: 'contact',
    privacyPolicy: 'privacy-policy'
}
